// Get the first of the nodes
r.prototype.first = function() {
    return this.nodes[0] || false;
};
